import React from "react";

const Footer = () => {
  return (
    <footer>
      <p>&copy; {new Date().getFullYear()}. Guidr</p>
    </footer>
  );
};

export default Footer;
